/* eslint-disable react/prop-types */
import React from 'react';

const COLORS = {
  greenDark: '#2D3A2E',
  greenMed: '#4A6741',
  greenLight: '#F0F4EF',
  greenBorder: '#C5D4C0',
  text: '#1A1A1A',
};

const CheckoutDisclosure = ({ agreed, onAgreeChange, inShippingFlow }) => {
  const renderNavigationText = inShippingFlow ? '(My Account > My Settings)' : '(Settings > Billing)';
  const renderLink = inShippingFlow ? '/onramp/my-settings' : '/settings/billing';

  return (
    <div style={{ padding: '0 0 20px' }}>
      <div style={{
        background: COLORS.greenLight,
        border: `1.5px solid ${COLORS.greenBorder}`,
        borderRadius: 6,
        padding: 18,
        marginBottom: 20,
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.greenDark, marginBottom: 8, letterSpacing: 0.2 }}>
          Subscription Auto-Renewal Terms
        </div>
        <div style={{ fontSize: 13, color: COLORS.text, lineHeight: 1.65 }}>
          Your subscription will automatically renew each week at the price shown above until you cancel.
          You may cancel at any time through your
          <span style={{ color: COLORS.greenMed, textDecoration: 'underline', cursor: 'pointer' }}>
            <a href={renderLink}> account settings </a>
          </span>
          {renderNavigationText} .
          Cancellations must be made by Sunday at 11:00 PM PT and will take effect for your next unlocked delivery week (8 days out).
          Your upcoming delivery for the current week is finalized upon payment each Sunday and cannot be cancelled.
          After cancellation, you will not be charged for future deliveries.
        </div>
      </div>

      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={agreed}
          onChange={() => onAgreeChange(!agreed)}
          style={{ marginTop: 3, width: 18, height: 18, accentColor: COLORS.greenMed, cursor: 'pointer', flexShrink: 0 }}
        />
        <span style={{ fontSize: 13, color: COLORS.text, lineHeight: 1.6 }}>
          I have read and agree to the{' '}
          <a href="https://gomethodology.com/terms-conditions" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.greenMed, textDecoration: 'underline', cursor: 'pointer' }}>Terms and Conditions</a>,
          including the automatic renewal and cancellation terms described above.
        </span>
      </label>

      {!agreed && (
        <p style={{ fontSize: 12, color: '#9CA3AF', textAlign: 'center', marginTop: 8 }}>
          Please agree to the Terms and Conditions to continue
        </p>
      )}
    </div>
  );
};

export default CheckoutDisclosure;
